module.exports = __webpack_public_path__ + "files/29e1295b704cf34ad1cff2b963bcc5ee.svg";